import * as React from 'react';
import { BaseContext } from 'src/com/sixdee/crbtportal/utils/basecontext';
import { AudioPlayerWithSeekbarHandler } from 'src/com/sixdee/crbtportal/utils/player/playerwithseekbar/audioplayerwithseekbarhandler';
import { AudioPlayerWithSeekbar, AudioPlayerWithSeekbarImpl } from 'src/com/sixdee/crbtportal/utils/player/playerwithseekbar/audioplayerwithseekbarImpl';
import { UIComponentHandler } from '../../uicomponent';
import { PlayerComponentProps, PlayerComponentState, PlayerComponentHandler } from '../playercomponent';
import { PlayerView } from '../playerview';
import { LandingPagePlayerCSSStyle } from './landingpageplayercss';
import './landingpageplayerwithseekbar.css';

export class LandingPagePlayerWithSeekbarView extends PlayerView implements AudioPlayerWithSeekbarHandler {
   
    private startTime: HTMLLabelElement;
    private endTime: HTMLLabelElement;
    private audioPlayerWithSeekbar: AudioPlayerWithSeekbar;

    constructor(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler) {
        super(applicationContext, uiComponentHandler);

        this.audioPlayerWithSeekbar = new AudioPlayerWithSeekbarImpl(applicationContext.getPlayerManager().getAudioPlayer());
        this.audioPlayerWithSeekbar.setAudioPlayerWithSeekBarHandler(this);
    }

    bindHandlers() {
        this.onPlayClicked = this.onPlayClicked.bind(this);
        this.onStopClicked = this.onStopClicked.bind(this);
    }

    draw(uiProps: PlayerComponentProps, uiState: PlayerComponentState, cssStyle: LandingPagePlayerCSSStyle): JSX.Element | boolean {
        super.draw(uiProps, uiState, cssStyle);

        return (
            <div style={cssStyle.getPlayDivCSSStyle()}>
               
                <input id="seek" className="slider" style={cssStyle.getSeekbarCSSStyle("0")} type={"range"} step={"1"} ref={(item: any) => { this.audioPlayerWithSeekbar.setSeekbar(item); }} onChange={this.audioPlayerWithSeekbar.changeCurrentTime}/>
                <div id="starttime-endtime-div" style={cssStyle.getStartTimePlayEndTimeDivCSSStyle()}>
                   
                    {
                        !uiState.isPlaying ?
                            <img  id="play-icon-img" onClick={this.onPlayClicked} style={cssStyle.getPlayIconCSSStyle()} src={uiProps.context.getResources().getImage("play_black.svg")} />
                            :
                            <img id="play-icon-img" onClick={this.onStopClicked} style={cssStyle.getPlayIconCSSStyle()} src={uiProps.context.getResources().getImage("pause_black.svg")} />
                    }
                     <label id="start-time-label" style={cssStyle.getStartTimeCSSStyle()} ref={(item: any) => { this.startTime = item; }}>{this.updateStartTime}</label>
                        <div id="slash-div" style={{marginLeft:'5px',marginRight:'5px',color:'#FFFFFF'}}>{"/"}</div>
                    <label id="end-time-label" style={cssStyle.getEndTimeCSSStyle()} ref={(item: any) => { this.endTime = item; }} >{this.updateEndTime}</label>

                </div>
            </div>);
    }

    updateSeekbarPlayedPartColor(percent: string): void 
    {
        let seekbarElement = document.getElementById('seek') as HTMLElement ;
        seekbarElement.style.background = "linear-gradient(to right, #D7006D 0%, #D7006D "+ percent +"%, #fff "+ percent +"%, #fff 100%)";
    }

    resetControls() {
        this.audioPlayerWithSeekbar.onReset();
    }

    unregisterAudioEvents() {
        this.audioPlayerWithSeekbar.unregisterAudioEvents();
    }

    getUIComponentHandler(): PlayerComponentHandler {
        return super.getUIComponentHandler() as PlayerComponentHandler;
    }

    getAudioPlayerWithSeekbar(): AudioPlayerWithSeekbar {
        return this.audioPlayerWithSeekbar;
    }

    updateStartTime(startTime: string): void 
    {
        if (this.startTime !== null) {
            this.startTime.innerHTML = startTime;
        }
    }
    updateEndTime(endTime: string): void {
        if (this.endTime !== null) {
            this.endTime.innerHTML = endTime;
        }
    }

    // updatePlayControlsRef(): void 
    // {
    //     this.audioPlayerWithSeekbar.setStartTimeRef(this.startTime);
    //     this.audioPlayerWithSeekbar.setEndTimeRef(this.endTime);
    // }

    /*  
    Added via base class
    private onPlayClicked(e: any)
     {
         e.stopPropagation();
         this.getUIComponentHandler().onPlayClicked();
     }
 
     private onStopClicked(e: any)
     {
         e.stopPropagation();
         this.getUIComponentHandler().onStopClicked();
     } */
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/player/landingpageplayer/landingpageplayerwithseekbarview.tsx